import Lot from '@/models/Lot';
import moment from 'moment';
import { Vue } from 'vue-property-decorator';

export default function getOptionInfos(lot: Lot): any {
    if(lot) {

        let start: boolean|string = false
        let end: boolean|string = false
        let updated: boolean|string = false
        let text: string = ''
        if(lot.option_start_at){
            start = moment(lot.option_start_at).format('DD/MM/YYYY HH:mm')
        }
        if(lot.option_end_at){
            end = moment(lot.option_end_at).format('DD/MM/YYYY HH:mm')
        }
        if(lot.updated_at){
            updated = moment(lot.updated_at).format('DD/MM/YYYY HH:mm')
        }

        if(updated){
            text = "<br>Statut du lot mis à jour le <strong>"+ updated +"</strong>";
        }
        if(start){
            text += "<br><br>Lot optionné depuis le <strong>"+ start +"</strong>";
        }
        if(end){
            text += "<br> jusqu'au <strong>"+ end +"</strong>";
        }

        // <span class='ml-1'>Me prevenir par mail si le lot revient disponible</span>
        return Vue.prototype.$vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Infos option',
            time: 10000,
            text: text,
        });
    }
}
